import { expectEl, expectEls, videoSrcOf } from "../util";
import { GameData } from "../gameData";
import { createGameContext } from "../gameContext";
import { popSceneHistory, switchScene } from "./switchScene";
import {
    replayVideo,
    skipVideo,
    togglePlay,
    updateNavBtns,
} from "./videoControl";

export function startGame(gameData: GameData) {
    createGameContext(gameData);

    setupVideos(gameData);
    setupNavBtns();
    setupKeybinds();

    switchScene(gameData.initialSceneId);
}

async function setupVideos(gameData: GameData): Promise<void> {
    const videosEl = expectEl("#game .videos");
    const videoSrcs = Array.from(
        Object.values(gameData.scenes).reduce((acc, scene) => {
            if (scene.video) {
                acc.add(`videos/${videoSrcOf(scene.video)}`);
            }
            if (scene.loop) {
                acc.add(`videos/${videoSrcOf(scene.loop)}`);
            }
            return acc;
        }, new Set<string>()),
    );
    for (const videoSrc of videoSrcs) {
        const ext = (videoSrc.match(/\.(\w+)$/) || [])[1];
        if (!ext) {
            throw new Error(`Scene video "${videoSrc}" has no extension`);
        }
        const el = document.createElement("video");
        const srcEl = document.createElement("source");
        srcEl.src = videoSrc;
        srcEl.type = `video/${ext}`;
        el.classList.add("video");
        el.setAttribute("data-src", videoSrc);
        el.appendChild(srcEl);
        videosEl.appendChild(el);
    }
}

function setupNavBtns() {
    const skipBtnEls = expectEls("#game .navBtns .skipBtn");
    skipBtnEls.forEach((el) => (el.onclick = skipVideo));

    const togglePlayBtnEls = expectEls("#game .navBtns .togglePlayBtn");
    togglePlayBtnEls.forEach((el) => (el.onclick = togglePlay));

    const replayBtnEls = expectEls("#game .navBtns .replayBtn");
    replayBtnEls.forEach((el) => (el.onclick = replayVideo));

    const sceneHistoryPopBtnEls = expectEls(
        "#game .navBtns .sceneHistoryPopBtn",
    );
    sceneHistoryPopBtnEls.forEach((el) => (el.onclick = popSceneHistory));

    updateNavBtns();
}

function setupKeybinds() {
    document.onkeydown = (event) => {
        const key = event.key.toLowerCase();
        switch (key) {
            case "s": {
                skipVideo();
                break;
            }
            case " ": {
                togglePlay();
                break;
            }
        }
    };
}
